import { authService } from './authService';

export class TokenManager {
  private static instance: TokenManager;
  private refreshTimer: NodeJS.Timeout | null = null;
  private isRefreshing = false;

  private constructor() {}

  public static getInstance(): TokenManager {
    if (!TokenManager.instance) {
      TokenManager.instance = new TokenManager();
    }
    return TokenManager.instance;
  }

  public startTokenRefresh(): void {
    this.stopTokenRefresh();
    
    const refreshInterval = 15 * 60 * 1000; // 15 minutes
    
    this.refreshTimer = setInterval(async () => {
      await this.refreshTokenIfNeeded();
    }, refreshInterval);
  }

  public stopTokenRefresh(): void {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
  }

  private async refreshTokenIfNeeded(): Promise<void> {
    if (this.isRefreshing) {
      return;
    }

    const token = authService.getToken();
    const admin = authService.getStoredAdmin();

    if (!token || !admin) {
      return;
    }

    try {
      this.isRefreshing = true;
      
      const response = await authService.refreshToken(admin.id, token);
      
      if (!response.success) {
        console.warn('Token refresh failed:', response.error);
        authService.logout();
        window.location.href = '/login';
      }
    } catch (error) {
      console.error('Token refresh error:', error);
      authService.logout();
      window.location.href = '/login';
    } finally {
      this.isRefreshing = false;
    }
  }

  public async handleApiError(status: number): Promise<boolean> {
    if (status === 401) {
      const token = authService.getToken();
      const admin = authService.getStoredAdmin();

      if (token && admin && !this.isRefreshing) {
        try {
          this.isRefreshing = true;
          const response = await authService.refreshToken(admin.id, token);
          
          if (response.success) {
            return true; // Token refreshed, retry the request
          }
        } catch (error) {
          console.error('Token refresh failed:', error);
        } finally {
          this.isRefreshing = false;
        }
      }
      
      authService.logout();
      window.location.href = '/login';
      return false;
    }
    
    return false;
  }
}

export const tokenManager = TokenManager.getInstance();